import React, { useEffect, useState } from 'react';
import api from '../api/client';
import { Bell, CheckCircle2, CircleDot } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('all');

  const load = async () => {
    const { data } = await api.get('/notifications');
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (n) => {
    if (n.read) return;
    await api.post(`/notifications/${n.id}/read`);
    load();
  };

  const markAll = async () => {
    await api.post('/notifications/read-all');
    load();
  };

  const unread = items.filter((i) => !i.read);
  const filtered = filter === 'unread' ? unread : filter === 'read' ? items.filter((i) => i.read) : items;

  const kindColor = (k) => ({
    approval: 'bg-blue-100 text-blue-700',
    approve: 'bg-green-100 text-green-700',
    reject: 'bg-red-100 text-red-700',
    info: 'bg-zinc-100 text-zinc-700',
  }[k] || 'bg-zinc-100 text-zinc-700');

  return (
    <div className="space-y-6 max-w-3xl" data-testid="notifications-page">
      <header className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <div className="overline">Inbox</div>
          <h1 className="heading text-3xl font-black text-ink">Notifications</h1>
          <p className="text-sm text-zinc-500 mt-1">{unread.length} unread · {items.length} total</p>
        </div>
        <button className="btn-outline" onClick={markAll} data-testid="mark-all-read"><CheckCircle2 size={14} /> Mark all read</button>
      </header>

      <div className="flex gap-1">
        {['all', 'unread', 'read'].map((f) => (
          <button key={f} onClick={() => setFilter(f)} data-testid={`n-filter-${f}`}
            className={`text-xs font-bold uppercase px-3 py-2 rounded-sm border ${filter === f ? 'bg-ink text-white border-ink' : 'bg-white border-zinc-300'}`}
          >{f}</button>
        ))}
      </div>

      <div className="card divide-y divide-zinc-100">
        {filtered.length === 0 && <div className="p-12 text-center text-zinc-400">No notifications.</div>}
        {filtered.map((n) => (
          <div key={n.id} className={`p-4 flex items-start gap-3 cursor-pointer ${!n.read ? 'bg-orange-50/50' : ''}`} onClick={() => markRead(n)} data-testid={`notif-${n.id}`}>
            <div className={`w-9 h-9 rounded-sm flex items-center justify-center ${kindColor(n.kind)}`}>
              <Bell size={14} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <div className="font-bold text-ink text-sm">{n.title}</div>
                {!n.read && <span className="w-2 h-2 rounded-full bg-primary pulse-dot" />}
              </div>
              <div className="text-sm text-zinc-600">{n.message}</div>
              <div className="text-[10px] text-zinc-400 mt-1">{n.created_at && formatDistanceToNow(new Date(n.created_at), { addSuffix: true })}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
